import { v4 as uuidv4 } from 'uuid';
import { COLUMN_LAYOUT, FORGOTTEN_FAVOURITES, HERO_BANNER, SHOP_WINDOWS, } from '../../constants/cmsResourceTypes';
const FULL_PAGE_COMPONENTS = [FORGOTTEN_FAVOURITES, HERO_BANNER, SHOP_WINDOWS];
const isFullWidth = ({ resourceType, fullWidth }) => fullWidth || FULL_PAGE_COMPONENTS.includes(resourceType);
const extractLastElement = array => [array.slice(0, array.length - 1), array[array.length - 1]];
const newCenterLayoutComponent = childComponents => ({
    componentId: `column-placeholder-${uuidv4()}`,
    childComponents,
    cqResponsive: {
        deviceBreakpoints: [
            { width: '12', name: 'xs', auto: false, visible: true },
            { width: '12', name: 'sm', auto: false, visible: true },
            { width: '12', name: 'md', auto: false, visible: true },
            { width: '12', name: 'lg', auto: false, visible: true },
            { width: '12', name: 'default', auto: false, visible: true },
        ],
    },
    resourceType: COLUMN_LAYOUT,
    styleIds: [],
    uniqueId: `column-placeholder-${uuidv4()}`,
});
const addColumnToLocation = components => {
    if (!components) {
        return undefined;
    }
    return components.reduce((previousValue, component) => {
        if (isFullWidth(component))
            return [...previousValue, component];
        const [restOfArray, previousComponent] = extractLastElement(previousValue);
        if (!previousComponent || isFullWidth(previousComponent))
            return [...previousValue, newCenterLayoutComponent([component])];
        return [
            ...restOfArray,
            Object.assign(Object.assign({}, previousComponent), { childComponents: [...previousComponent.childComponents, component] }),
        ];
    }, []);
};
export default input => Object.entries(input).reduce((previousValue, [key, object]) => (Object.assign(Object.assign({}, previousValue), { [key]: addColumnToLocation(object) })), {});
//# sourceMappingURL=add-column-component-to-content-response.js.map